<template>
  <div style="width: 100%;height: 100%;" class="customcarouse">
    <el-carousel style="width: 100%;height: 100%;" :direction="chartConfigModel.direction" :autoplay="autoplay"
    :interval="interval" :indicator-position="chartConfigModel.indicatorPosition">
        <el-carousel-item v-for="item in chartConfigModel.imagesList" :key="item.id">
          <el-image style="width:100%;height:100%"
                :src="getUrl(item.id)"
                fit="fill"/>
        </el-carousel-item>
      </el-carousel>
  </div>
</template>
<style>
</style>
<script>
   import lodash from 'lodash'
  export default {
    props: {
      width: {
        type: String,
        default: '300px'
      },
      height: {
        type: String,
        default: '30px'
      },
      chartConfig: {
				type: Object,
				default: function(){
          return {

          }
        }
			}
    },
    computed:{
      interval(){
        return (this.chartConfigModel.interval?this.chartConfigModel.interval:3)*1000
      },
      autoplay(){
        if("1"==this.chartConfigModel.autoplay){
          return true
        }
        return false
      }
    },
    methods:{
      getUrl(id){
        if(this.chartConfigModel && this.chartConfigModel.uploadUrl && this.chartConfigModel.authorization){
          return this.chartConfigModel.uploadUrl+'/upload/preView?Authorization='+this.chartConfigModel.authorization+'&id='+id
        }
        return ""
      },
      setConfig(data){
        this.chartConfigModel = lodash.cloneDeep(data)
        let _config = lodash.cloneDeep(this.defaultConfig)
        lodash.merge(_config, this.chartConfigModel)
        this.chartConfigModel = _config
      }
    },
    mounted() {
     this.setConfig(this.chartConfig)
    },
    watch: {
      // 防止表格预置数据不成功，涉及生命周期问题
      chartConfig: {
        handler(newValue, oldValue) {
          this.setConfig(newValue)
        },
        deep: true
      }
    },
    data() {
      return {
        chartConfigModel: {},
        defaultConfig: {
          uploadUrl:'',
          authorization:'',
          autoplay:'1',
          direction:'horizontal',
          indicatorPosition:'none',//指示器位置
          interval:3,//自动切换的时间间隔，单位为秒
          imagesList:[]
        }
      }
    }
}
</script>

<style>
  .customcarouse .el-carousel__container{
    width:100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/images/Carousel.vue